import React, { useState } from "react";
import { Button, Form, Icon } from "semantic-ui-react";
import brithdayLogo from '../containers/icons/birthday-icon.png';

const NoteSelector = ({
  label,
  labelTwo,
  name,
  notes = [],
  notesTwo = [],
  register,
  setValue,
  watch,
  t,
  birthdateInCruise
}) => {
  const [selected, setSelected] = useState("notOption");

  const currentValue = watch(name) || "";

  const handleInsert = () => {
    if (!selected || selected === "notOption") return;

    const separator = currentValue ? "\n" : "";
    const newValue = currentValue + separator + selected;

    setValue(name, newValue);
    setSelected("notOption");
  };

  return (
    <>
      <Form.Group widths="equal">
        <Form.Field>
          <label>{label}</label>
          <select
            value={selected}
            onChange={(e) => setSelected(e.target.value)}
          >
            <option value="notOption"></option>
            {notes.map((note) => (
              <option key={note.id} value={note.message}>
                {note.message}
              </option>
            ))}
          </select>
        </Form.Field>
        <Form.Field width="1">
          <br />
          <Button icon color="blue" type="button" onClick={handleInsert}>
            <Icon name="plus" />
          </Button>
        </Form.Field>
      </Form.Group>
      {notesTwo.length ?
        <Form.Group widths="equal">
          <Form.Field>
            <label>{labelTwo}</label>
            <select
              value={selected}
              onChange={(e) => setSelected(e.target.value)}
            >
              <option value="notOption"></option>
              {notesTwo.map((note) => (
                <option key={note.id} value={note.message}>
                  {note.message}
                </option>
              ))}
            </select>
          </Form.Field>
          <Form.Field width="1">
            <br />
            <Button icon color="blue" type="button" onClick={handleInsert}>
              <Icon name="plus" />
            </Button>
          </Form.Field>
        </Form.Group>
        : ''
      }

      <Form.Group widths="equal">
        <Form.Field>
          <div style={{ "display": "flex", "justify-content": "space-between", "align-items": "center", "font-weight": "700", "font-size": ".92857143em" }}>
            {(birthdateInCruise && name === 'special_requirements') ? (
              <div style={{ "display": "flex", "align-items": "center", "gap": "4px" }}>
                <img style={{ "width": "30px", "padding-bottom": "4px" }} src={brithdayLogo} alt="brithday" />
                <p style={{ "padding-top": "4px" }}>{t("spacePassenger_birthday_message")}</p>
              </div>
            ) : ''}
          </div>
          <textarea
            rows={3}
            name={name}
            placeholder={label}
            ref={register}
          ></textarea>
        </Form.Field>
      </Form.Group>
    </>
  );
};

export default NoteSelector;
